import type { CreateWineryDto, GetWineryDto, UpdateWineryDto, WineryDto } from './models';
import { RestService, Rest } from '@abp/ng.core';
import type { PagedResultDto } from '@abp/ng.core';
import { Injectable } from '@angular/core';
import type { CountryDto } from '../countries/models';

@Injectable({
  providedIn: 'root',
})
export class WineryService {
  apiName = 'Default';
  

  create = (input: CreateWineryDto, config?: Partial<Rest.Config>) =>
    this.restService.request<any, WineryDto>({
      method: 'POST',
      url: '/api/app/winery',
      body: input,
    },
    { apiName: this.apiName,...config });
  

  delete = (id: number, config?: Partial<Rest.Config>) =>
    this.restService.request<any, void>({
      method: 'DELETE',
      url: `/api/app/winery/${id}`,
    },
    { apiName: this.apiName,...config });
  

  deleteFileByFileAttachmentId = (fileAttachmentId: number, config?: Partial<Rest.Config>) =>
    this.restService.request<any, boolean>({
      method: 'DELETE',
      url: `/api/app/winery/file/${fileAttachmentId}`,
    },
    { apiName: this.apiName,...config });
  

  get = (id: number, config?: Partial<Rest.Config>) =>
    this.restService.request<any, WineryDto>({
      method: 'GET',
      url: `/api/app/winery/${id}`,
    },
    { apiName: this.apiName,...config });
  

  getCountries = (config?: Partial<Rest.Config>) =>
    this.restService.request<any, CountryDto[]>({
      method: 'GET',
      url: '/api/app/winery/countries',
    },
    { apiName: this.apiName,...config });
  

  getFileByFileAttachmentId = (fileAttachmentId: number, config?: Partial<Rest.Config>) =>
    this.restService.request<any, Blob>({
      method: 'GET',
      responseType: 'blob',
      url: `/api/app/winery/file/${fileAttachmentId}`,
    },
    { apiName: this.apiName,...config });
  

  getList = (input: GetWineryDto, config?: Partial<Rest.Config>) =>
    this.restService.request<any, PagedResultDto<WineryDto>>({
      method: 'GET',
      url: '/api/app/winery',
      params: { keyword: input.keyword, sorting: input.sorting, skipCount: input.skipCount, maxResultCount: input.maxResultCount },
    },
    { apiName: this.apiName,...config });
  

  update = (id: number, input: UpdateWineryDto, config?: Partial<Rest.Config>) =>
    this.restService.request<any, WineryDto>({
      method: 'PUT',
      url: `/api/app/winery/${id}`,
      body: input,
    },
    { apiName: this.apiName,...config });
  

  uploadFileByFile = (file: FormData, config?: Partial<Rest.Config>) =>
    this.restService.request<any, number>({
      method: 'POST',
      url: '/api/app/winery/upload-file',
      body: file,
    },
    { apiName: this.apiName,...config });

  constructor(private restService: RestService) {}
}
